import React, { useState, useEffect } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { useDispatch } from 'react-redux';
import { updateQty } from '../../flux/actions/shoppingCart-actions';
import "../../styles/Products/ButonStyle.scss";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "& > *": {
        margin: theme.spacing(1),
        width: "25ch",
      },
    },
  })
);

export default function AddButtons(props:any) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [count, setCount] = useState(props.qty || 1);

  useEffect(() => {
    if (props.itemId) {
      dispatch(updateQty(props.itemId, count));
    }
  }, [count, props.itemId, dispatch])

  const negativeCheck = (e: React.ChangeEvent<HTMLInputElement>) => {
    let firstChange = e.target.value.replace(/^0+/, "");
    let temporalCount = parseInt(firstChange);
    if (temporalCount < 0) temporalCount = 0;
    if (temporalCount >= props.max) {
      props.showError(true);
      temporalCount = props.max;
    } else {
      props.showError(false);
    }
    if (isNaN(temporalCount)) {
      temporalCount = 0;
    }
    setCount(temporalCount);
  };

  const setZero = (e: React.ChangeEvent<HTMLInputElement>) => {
    let temporalCount = parseInt(e.target.value);
    if (isNaN(count) || isNaN(temporalCount) || temporalCount === 0)
      temporalCount = 1;
    props.showError(false);
    setCount(temporalCount);
  };

  return (
    <div className={classes.root}>
      <button
        onClick={() => 
          {
            props.showError(false);
            setCount(props.qty <= 1 ? 1 : props.qty - 1);
          }
        }
        className="buttonStyleAdd "
      >
        -
      </button>
      <input
        className="quantityStyle"
        type="text"
        value={props.qty}
        onChange={negativeCheck}
        onBlur={setZero}
      />
      <button
        onClick={() => {
            props.showError(false);
            if (props.qty >= props.max) {
              props.showError(true);
              setCount(props.max);
            } else {
              setCount(props.qty + 1);
            }
          }
        }
        className="buttonStyleAdd "
      >
        +
      </button>
    </div>
  );
}
